import { render, staticRenderFns } from "./select-labs.vue?vue&type=template&id=6a3899dc&scoped=true&"
import script from "./select-labs.vue?vue&type=script&lang=js&"
export * from "./select-labs.vue?vue&type=script&lang=js&"
import style0 from "./select-labs.vue?vue&type=style&index=0&id=6a3899dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3899dc",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CFlex: require('@chakra-ui/vue').CFlex})
